import React from "react";
import "./style.css";
import classNames from "classnames";
export default function ProTip(props) {
    return (React.createElement("div", { className: classNames("protip-container", {
            "protip-container-no-padding": props.disableMargin,
            "protip-container-auto-fit": props.autoFit,
        }) },
        props.withoutPrefix === true ?
            React.createElement(React.Fragment, null)
            : React.createElement("span", null, "Rada:"),
        props.children));
}
